/**
 * Map API / legacy row shapes into the form state shape (stateAddress + pincode).
 */
export function normalizeShippingRowsFromApi(rows) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return [
      {
        fullname: "",
        address: "",
        stateAddress: "",
        city: "",
        pincode: "",
      },
    ];
  }
  return rows.map((raw) => ({
    fullname: raw.fullname ?? "",
    address: raw.address ?? "",
    stateAddress:
      raw.stateAddress != null && raw.stateAddress !== ""
        ? raw.stateAddress
        : raw.state ?? "",
    city: raw.city ?? "",
    pincode:
      raw.pincode != null && raw.pincode !== ""
        ? raw.pincode
        : raw.pin ?? "",
  }));
}

/**
 * Shipping rows for Account create/update — plain JSON-friendly objects for Mongoose.
 * Autocomplete may store strings or objects; we normalize to strings the API can store.
 */
export function serializeShippingAddressesForApi(rows) {
  if (!Array.isArray(rows)) return [];

  const asStr = (v) => {
    if (v == null || v === "") return "";
    if (typeof v === "string") return v;
    if (typeof v === "object" && v.name != null) return String(v.name);
    return String(v);
  };

  return rows.map((row) => ({
    fullname: asStr(row.fullname),
    address: asStr(row.address),
    stateAddress: asStr(
      row.stateAddress != null && row.stateAddress !== ""
        ? row.stateAddress
        : row.state
    ),
    city: asStr(row.city),
    pincode:
      row.pincode != null && row.pincode !== ""
        ? String(row.pincode)
        : row.pin != null && row.pin !== ""
          ? String(row.pin)
          : "",
  }));
}
